define('static/js/captcha', function(require, exports, module) {

  var api = require('static/js/api')
  var captcha = {
    init: function (from, cb) {
      require(['static/js/jquery','static/js/common','static/js/cookie','static/js/proxy','static/js/language','static/js/jQueryMd5','static/js/api'], function ($, commonJS, cookieJS, proxyJS, languageJS, md5, api) {
        var dialog = $("#ssj_dialog")[0]
        var dots = []
        var mask = $("#mask")[0]
        var thumbBase64 = $("#dialog_captcha_thumbBase64")[0]
        var imageBase64 = $("#dialog_captcha_imageBase64")[0]
        var close = $("#dialog_captcha_close")[0]
        var refresh = $("#dialog_captcha_refresh")[0]
        var confirm = $("#dialog_captcha_confirm")[0]
        var appID = proxyJS.proxyObj.appId;
        var appKey = proxyJS.proxyObj.appKey;
        var channelID = proxyJS.proxyObj.channelID;
        var subChannelID = proxyJS.proxyObj.subChannelID;
        var verifyToken = null
        close.addEventListener("click", diaogClose, true);
        refresh.addEventListener("click", diaogRefresh, true);
  
        // 为防止别人多次点击diaogRefresh
  
        function initApi() {
          api.captchaApi({
            appID: appID,
            channelID: channelID,
            subChannelID: subChannelID,
            appKey: appKey,
            from: from
          }, function (r) {
            console.log(r);
            if (r.code === 0) {
              thumbBase64.src = r.data.thumbBase64
              imageBase64.src = r.data.imageBase64
              verifyToken = r.data.verifyToken
              imageBase64.addEventListener("click", diaogClickPos, true);
              close.addEventListener("click", diaogClose, true);
              refresh.addEventListener("click", diaogRefresh, true);
              confirm.addEventListener("click", diaogConfirm, true);
            }
          })
        }
  
        initApi()
  
        function diaogClickPos(event) {
          event.preventDefault();
          var dom = event.currentTarget;
  
          var domRect = dom.getBoundingClientRect();
          var mouseX = event.clientX - domRect.left;
          var mouseY = event.clientY - domRect.top;
  
          var newDot = {
            x: mouseX - 11,
            y: mouseY - 11,
            index: dots.length + 1,
          };
  
          dots.push(newDot)
          updateDots();
        }
  
        function updateDots() {
          var dotsContainer = document.querySelector('.dialog_captcha_content');
  
          dots.forEach(function (item) {
            var dot = document.createElement('div');
            dot.className = 'dialog_captcha_dots';
            dot.style.top = item.y + 'px';
            dot.style.left = item.x + 'px';
  
            var span = document.createElement('span');
  
            span.textContent = item.index;
  
            span.onclick = function () {
              handleRemoveEvent(item);
            };
  
            dot.appendChild(span);
            dotsContainer.appendChild(dot);
          });
        }
  
        function diaogClose(event) {
          console.log('关闭');
          dialog.style.display = "none";
          mask.style.display = "none";
          dots = []
          var parentDiv = document.querySelector('.dialog_captcha_content');
          var Elements = parentDiv.querySelectorAll('.dialog_captcha_dots');
          Elements.forEach(function (ele) {
            if (ele.tagName.toLowerCase() !== 'img') {
              parentDiv.removeChild(ele);
            }
          });
          imageBase64.removeEventListener("click", diaogClickPos, true);
          close.removeEventListener("click", diaogClose, true);
          refresh.removeEventListener("click", diaogRefresh, true);
          confirm.removeEventListener("click", diaogConfirm, true);
        }
  
        function debounce(func, wait) {
          var timeout;
          return function () {
            var context = this;
            var args = arguments;
            var immediate = !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(function () {
              timeout = null;
              if (!immediate) func.apply(context, args);
            }, wait);
            if (immediate) func.apply(context, args);
          };
        }
  
        var diaogRefreshDebounced = debounce(function () {
          console.log('刷新');
          api.captchaApi({
            appID: appID,
            channelID: channelID,
            subChannelID: subChannelID,
            appKey: appKey,
            from: from
          }, function (r) {
            if (r.code === 0) {
              dots = [];
              var parentDiv = document.querySelector('.dialog_captcha_content');
              var Elements = parentDiv.querySelectorAll('.dialog_captcha_dots');
              Elements.forEach(function (ele) {
                if (ele.tagName.toLowerCase() !== 'img') {
                  parentDiv.removeChild(ele);
                }
              });
              thumbBase64.src = r.data.thumbBase64;
              imageBase64.src = r.data.imageBase64;
              verifyToken = r.data.verifyToken;
            }
          });
        }, 2000); // 设置延迟时间，例如500毫秒
  
  
        function diaogRefresh() {
          diaogRefreshDebounced();
        }
  
        // function diaogRefresh() {
        //   console.log('刷新');
        //   api.captchaApi({
        //     appID: appID,
        //     channelID: channelID,
        //     subChannelID: subChannelID,
        //     appKey: appKey,
        //     from: from
        //   }, function (r) {
        //     if (r.code === 0) {
        //       dots = []
        //       var parentDiv = document.querySelector('.dialog_captcha_content');
        //       var Elements = parentDiv.querySelectorAll('.dialog_captcha_dots');
        //       Elements.forEach(function (ele) {
        //         if (ele.tagName.toLowerCase() !== 'img') {
        //           parentDiv.removeChild(ele);
        //         }
        //       });
        //       thumbBase64.src = r.data.thumbBase64
        //       imageBase64.src = r.data.imageBase64
        //       verifyToken = r.data.verifyToken
        //     }
        //   })
        // }
  
        function diaogConfirm() {
          var dotArr = [];
          dots.forEach((dot) => {
            dotArr.push(dot.x, dot.y);
          });
          api.checkeCaptchaApi({
            appID: appID,
            channelID: channelID,
            subChannelID: subChannelID,
            appKey: appKey,
            from: from,
            verifyDots: dotArr.join(","),
            verifyToken: verifyToken
          }, function (r) {
            if (r.data.check === 1) {
              cb(r.data.passToken)
              diaogClose()
            } else {
              api.captchaApi({
                appID: appID,
                channelID: channelID,
                subChannelID: subChannelID,
                appKey: appKey,
                from: from
              }, function (r) {
                if (r.code === 0) {
                  dots = []
                  var parentDiv = document.querySelector('.dialog_captcha_content');
                  var Elements = parentDiv.querySelectorAll('.dialog_captcha_dots');
                  Elements.forEach(function (ele) {
                    if (ele.tagName.toLowerCase() !== 'img') {
                      parentDiv.removeChild(ele);
                    }
                  });
                  thumbBase64.src = r.data.thumbBase64
                  imageBase64.src = r.data.imageBase64
                  verifyToken = r.data.verifyToken
                }
              })
            }
          })
        }
  
      })
    },
    passToken: null
  }
  exports.captcha = captcha;
  

});
